import { connect } from "react-redux";
import Gradebook from "../../components/Journal/Gradebook";
import { displayPage } from "../../actions/research";

const mapStateToProps = state => {
  return {
    exercises: state.research.exercises.filter(
      item => item.category !== "build"
    ),
    grades: state.grades.gradebook
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showResearchPage: code => {
      dispatch(displayPage(code));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Gradebook);
